var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MultiItemBox',{attrs:{"data":(_vm.formConfig().currentWidget || {}).childWidgetList,"addText":"添加标签页","prop":{
    label: 'showName',
    value: 'variableName',
  }},on:{"add":function($event){return _vm.onEditTabPanel()},"edit":_vm.onEditTabPanel,"delete":_vm.onRemoveTabPanel}})
}
var staticRenderFns = []

export { render, staticRenderFns }